import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export default function AlertsPanel({ onClose }: { onClose: () => void }) {
  const alerts = useSelector((s: RootState) => s.fleet.detailedAlerts);

  return (
    <div className="absolute top-16 right-4 w-80 max-h-[400px] overflow-y-auto bg-white shadow-lg rounded-lg border border-gray-300 z-50">
      <div className="flex justify-between items-center px-4 py-2 border-b bg-[#f1f4ff]">
        <h3 className="font-semibold text-sm text-[#0b1220]">Recent Alerts</h3>
        <button onClick={onClose} className="text-sm text-gray-600 hover:text-black">✕</button>
      </div>

      <div className="divide-y divide-gray-200">
        {alerts.length === 0 && (
          <div className="text-center text-gray-500 py-6 text-sm">No alerts yet</div>
        )}

        {alerts.map((a) => (
          <div key={`${a.tripId}-${a.ts}`} className="px-4 py-2 text-[13px] hover:bg-gray-50">
            <div className="font-medium text-[#0b1220]">{a.message}</div>
            <div className="text-gray-600">
              Vehicle: <b>{a.vehicleId}</b> | Trip: {a.tripId}
            </div>
            <div className="text-gray-400 text-xs">
              {new Date(a.ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
